import { notification } from 'tea-component';

const successText = 'Operation is successful';
const errorText = 'Operation failed. Please try again';
export const notificationSuccess = (text = successText) =>
  notification.success({
    description: text,
  });

export const notificationError = (text = errorText) =>
  notification.error({
    description: text,
  });

export const specialReport: {
  [key: string]: Array<{
    text: string;
    activeId: string;
    url: string;
  }>;
} = {
  edd35f56eec157e048662aa043c0017f9: [
    {
      text: '1.5 Years Summary',
      activeId: 'yearsSummary',
      url: 'https://ogdb-cdn.intlgame.cn/opinion/prod/report/gpt/dying-light2/dying-light2-yearly-summary-2023-10-15-10-all-v4-1698406108.md',
    },
  ],
  e11000000297: [
    {
      text: 'CA7 Feedback Report',
      activeId: 'ca7FeedbackReport',
      url: 'https://ogdb-cdn.intlgame.cn/opinion/prod/report/gpt/nightingale/nightingale-weekly-summary-2023-11-12-02-all-v3-1700845885.md',
    },
    {
      text: 'CA7 Bug Report',
      activeId: 'ca7BugReport',
      url: 'https://ogdb-cdn.intlgame.cn/opinion/prod/report/gpt/nightingale/nightingale-weekly-summary-2023-11-12-00-all-v3-1700830831.md',
    },
    {
      text: 'CA7 Performance Report',
      activeId: 'ca7PerformanceReport',
      url: 'https://ogdb-cdn.intlgame.cn/opinion/prod/report/gpt/nightingale/nightingale-weekly-summary-2023-11-11-01-all-v3-1700835825.md',
    },
    {
      text: 'IGN Video Report',
      activeId: 'ignVideoReport',
      url: 'https://ogdb-bucket-1300342648.cos.ap-singapore.myqcloud.com/opinion/prod/report/gpt/nightingale/nightingale-weekly-summary-2024-02-01-00-all-v3-1706794477.md',
    },
    {
      text: 'Server Weekly',
      activeId: 'serverWeekly',
      url: 'https://ogdb-cdn.intlgame.cn/opinion/prod/report/gpt/nightingale/nightingale-weekly-summary-2024-02-29-00-all-v3-1709141575.md',
    },
  ],
  uef4312b08dde07820374dd57086ea2fb: [
    {
      text: 'Questionnaire Feedback',
      activeId: 'questionnaireFeedback',
      url: 'https://ogdb-cdn.intlgame.cn/opinion/prod/report/gpt/nikke/nikke-daily-summary-2024-01-25-00-all-v3-1706499570.md',
    },
  ],
};

export const specialReportIds = Object.values(specialReport)
  .flat(2)
  .map((item) => item.activeId);
